import { Component, Inject, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from '@angular/core';
import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../../services/authentication.service';
import { IdiomaService } from '../../../services/idioma.service';
import { StorageService } from '../../../services/storage.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { IconSetService } from '@coreui/icons-angular';
import { ModoVisionService } from '../../../services/modoVision.service';
import { Utils } from '../../../models/utils';
import { UtilsService } from '../../../services/utils.service';

export interface Flag {
  value: string;
  viewValue: string;
  img: string;
}

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
  providers: [AuthenticationService, StorageService],
  encapsulation: ViewEncapsulation.None,
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit {

  @Input() mostrarOcultarMenuLateral: boolean = false;

  @Output() propagar = new EventEmitter<string>();

  private changes: MutationObserver;
  public sidebarMinimized = true;
  public logoUrl: String;
  selectedLanguage$: Observable<String>;
  selectedLanguage;
  public modoNocturno: boolean = false;
  public date: String;
  tiendaSeleccionada = false;

  flags: Flag[] = [
    { value: 'es', viewValue: 'combos.espanol', img: '/assets/img/flag/es_ES.png' },
    { value: 'en', viewValue: 'combos.ingles', img: '/assets/img/flag/en_US.png' },
    { value: 'fr', viewValue: 'combos.frances', img: '/assets/img/flag/fr_FR.png' },
    { value: 'pt', viewValue: 'combos.portugues', img: '/assets/img/flag/pt_PT.png' },
    { value: 'ca', viewValue: 'combos.catalan', img: '/assets/img/flag/ca_CA.png' }
  ];

  constructor(
    private classToggler: ClassToggleService,
    public authenticationService: AuthenticationService,
    public storageService: StorageService,
    public idiomaService: IdiomaService,
    public modoVisionService: ModoVisionService,
    private translateService: TranslateService,
    private router: Router,
    public iconSet: IconSetService,
    private utilsService: UtilsService,
    @Inject(DOCUMENT) _document?: any) {
    super();

    this.setAppLanguage();

    setInterval(() => {
      const currentDate = new Date();
      this.date = Utils.capitalize(currentDate.toLocaleTimeString(this.selectedLanguage, { weekday: 'short', hour: '2-digit', minute: '2-digit' }));
    }, 1000);

    this.logoUrl = "assets/img/brand/ooh-la-la.svg";

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
  }

  ngOnInit(): void {
    this.utilsService.tienda$.subscribe(tienda => {
      this.tiendaSeleccionada = !!tienda?.id;
    });
  }

  toggleTheme() {
    this.modoNocturno = !this.modoNocturno;
    this.modoVisionService.changeModoVision(this.modoNocturno);
    if (this.modoNocturno) {
      this.logoUrl = "assets/img/brand/ooh-la-la-light.svg";
    } else {
      this.logoUrl = "assets/img/brand/ooh-la-la-light.svg";
    }
    this.classToggler.toggle('.c-app', 'c-dark-theme');
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
    //Si es una administrador vamos a clientes sino a visitas
    if (this.storageService.isAuthenticated()) {
      if (this.storageService.hasRole('ROLE_ADMIN')) {
        this.router.navigate(['/main']);
      } else {
        this.router.navigate(['/main']);
      }
    }
  }

  logout(): void {
    this.authenticationService.logout().subscribe(
      response => {
        if (response) {
          this.utilsService.clearCurrentTiendaId();
          this.storageService.logout();
        }
      }
    );
  }


  toogleLanguage(lang: string) {
    this.idiomaService.changeSelectedLanguage(lang);
    this.selectedLanguage = this.idiomaService.selectedLanguage;
    this.translateService.use(this.selectedLanguage);

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {

      //Avisar al padre de que ha cambiado el idioma
      this.propagar.emit();

    });

  }

  setAppLanguage() {
    this.toogleLanguage(this.idiomaService.selectedLanguage);
  }

  getIconsView(prefix: string) {
    /*return Object.entries(this.iconSet.icons).filter((icon) => {
      return icon[0].startsWith(prefix);
    });*/
    return this.iconSet.getIcon('prefix');
  }
}
